<div class="h2 content-title text-center p-3">
  Felettes, felügyeleti, törvényességi ellenőrzést gyakorló szervek
</div>

<div class="content my-3 col-lg-10 mx-auto mx-5">
  <div class="px-5 col-lg-8 mx-auto my-4">
    <div class="row">
      <div class=" col-lg-6 text-center ">Hivatalos név (teljes név):</div>
      <div class=" col-lg-6 text-center">Állami Számvevőszék</div>
    </div>
    <div class="row">
      <div class=" col-lg-6 text-center ">Székhely:</div>
      <div class=" col-lg-6 text-center">
        1052 Budapest, Apáczai Cs. J. u. 10.
      </div>
    </div>
    <div class="row">
      <div class=" col-lg-6 text-center ">Postacím:</div>
      <div class=" col-lg-6 text-center">1364 Budapest 4. Pf. 54</div>
    </div>
    <div class="row">
      <div class=" col-lg-6 text-center ">Központi telefonszám:</div>
      <div class=" col-lg-6 text-center">+36 1 484 9100</div>
    </div>
    <div class="row">
      <div class=" col-lg-6 text-center ">Központi telefax:</div>
      <div class=" col-lg-6 text-center">+36 1 484 9200</div>
    </div>
    <div class="row">
      <div class=" col-lg-6 text-center ">Központi e-mail:</div>
      <div class=" col-lg-6 text-center">szamvevoszek kukac asz pont hu</div>
    </div>
    <div class="row bb pb-5">
      <div class=" col-lg-6 text-center ">Internet honlap:</div>
      <div class=" col-lg-6 text-center">
        <a href="http://www.asz.hu" target="_blank">www.asz.hu</a>
      </div>
    </div>

    <div class="row  mt-5">
      <div class=" col-lg-6 text-center ">Hivatalos név (teljes név):</div>
      <div class=" col-lg-6 text-center">
        Komárom-Esztergom Megyei Kormányhivatal
      </div>
    </div>
    <div class="row">
      <div class=" col-lg-6 text-center ">Székhely:</div>
      <div class=" col-lg-6 text-center">
        2800 Tatabánya, Bárdos László utca 2.
      </div>
    </div>
    <div class="row">
      <div class=" col-lg-6 text-center ">Postacím:</div>
      <div class=" col-lg-6 text-center">
        2800 Tatabánya, Bárdos László utca 2.
      </div>
    </div>
    <div class="row">
      <div class=" col-lg-6 text-center ">Központi telefonszám:</div>
      <div class=" col-lg-6 text-center">+36 34 515 100</div>
    </div>
    <div class="row">
      <div class=" col-lg-6 text-center ">Központi telefax:</div>
      <div class=" col-lg-6 text-center">+36 34 515 109</div>
    </div>
    <div class="row">
      <div class=" col-lg-6 text-center ">E-mail cím:</div>
      <div class=" col-lg-6 text-center">
        hivatal kukac komarom pont govponthu
      </div>
    </div>
    <div class="row">
      <div class=" col-lg-6 text-center ">Internet honlap:</div>
      <div class=" col-lg-6 text-center">
        <a href="http://www.kemkh.hu/" target="_blank">www.kemkh.hu</a>
      </div>
    </div>
  </div>
</div>
